import styled from 'styled-components';
import { defaultColors } from '@components/themes';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { Column, Columns } from '@components/Columns';

interface BubbleProps
  extends Readonly<{
    left?: string;
    top?: string;
    bottom?: string;
    right?: string;
    zIndex?: number;
    width?: string;
    height?: string;
    blur?: boolean;
  }> {}

export const SquareBubble = styled.div<BubbleProps>`
  background-color: ${defaultColors.mono7};
  border: 4px solid ${defaultColors.purple1};
  border-radius: 8px;
  padding: 24px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => (props.width ? props.width : '298px')};
  height: ${props => (props.height ? props.height : '161px')};
  position: absolute;
  left: ${props => props.left};
  right: ${props => props.right};
  top: ${props => props.top};
  opacity: ${props => (props.blur ? 0.5 : 1)};
  filter: ${props => (props.blur ? 'blur(6px)' : undefined)};
  bottom: ${props => props.bottom};
  z-index: ${props => props.zIndex};
  transform: translateY(20vh);
  > p {
    text-align: center;
    margin: 12px 0;
  }
`;

export const StyledSection = styled(Box)`
  height: 100vh;
  align-items: center;
  position: relative;
  z-index: 0;
  overflow: hidden;
`;

export const StyledColumns = styled(Columns)`
  height: 100%;
`;

export const MainColumn = styled(Column)`
  height: 100%;
  position: relative;
`;

export const MainTextContainer = styled(Flex)`
  transform: translateY(100vh);
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const BubblesWrapper = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  width: 100%;
  max-width: 1440px;
  height: 500px;
  left: 50%;
  transform: translateX(-50%);
`;

export const Line = styled.div<{ height: string }>`
  border: 2px solid ${defaultColors.purple3};
  height: calc(20vh + ${props => props.height});
  position: absolute;
  bottom: 90%;
  border-radius: 2px;
`;

export const Dot = styled.div`
  width: 13px;
  height: 13px;
  border-radius: 100%;
  background-color: ${defaultColors.purple1};
  position: absolute;
  bottom: 85%;
  right: 50%;
  transform: translateX(50%);
`;
